import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import AButton from 'views/pages/manage/common/form-fields-mui/AButton'
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput'
import { FILTER__FORM_FIELDS_GLOBAL, SEARCH_BY } from "./constant";
import ReceiptListComponent from './ReceiptListComponent';
import { regex } from "views/pages/manage/common/constant/regex/index";
import { getCashDepositDetails } from './utils';

const CashReceiptDetail = ({ data }) => {

    const { details, setDetails, loading, setLoading, paginationInfo, setPaginationInfo, onViewSlip, dropdowns, cashReceiptId } = data;
    const [selected, setSelected] = useState("psid");
    const [searchInput, setSearchInput] = useState("");
    const [filterForm, setFilterForm] = useState({
        ...FILTER__FORM_FIELDS_GLOBAL,
    });
    const searchInputHandler = async (value = searchInput) => {
        try {
            setLoading(true);
            const updatedFilters = {
                ...filterForm,
                searchBy: value ? selected : "",
                searchByValue: value,
            };
            const psid = value ? value : null;
            const reqObj = {
                depositSlipId: Number(cashReceiptId),
                psid: psid
            }
            const res = await getCashDepositDetails({ pageNo: 0, pageSize: paginationInfo?.currPageSize, setPaginationInfo, reqObj, fetchLogs: true });
            setDetails(res);
            setFilterForm(updatedFilters);
        }
        catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            searchInputHandler();
        }
    };

    const handleOnUserInput = (value) => {
        setSearchInput(value);
        if (value === "" && value !== filterForm.searchByValue)
            searchInputHandler(value);
    };

    const crossHandler = async () => {
        try {
            setLoading(true);
            const reqObj = {
                depositSlipId: Number(cashReceiptId)
            }
            const res = await getCashDepositDetails({ pageNo: 0, pageSize: paginationInfo?.currPageSize, setPaginationInfo, reqObj, fetchLogs: true });
            setDetails(res);
            setFilterForm((prev) => ({ ...prev, searchByValue: '' }));
            setSearchInput("");
        }
        catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const handleView = (s3Key) => {
        if (onViewSlip) {
            onViewSlip(s3Key);
        } else {
            console.log("View Slip", s3Key);
        }
    };

    return (
        <Card>
            <div className='d-flex justify-content-between my-3 mx-3'>
                <div>
                    {details?.totalRecords} Receipts
                </div>

                <div className='d-flex justify-content-between' style={{ gap: "8px" }}>
                    <AButton
                        className="tiny-semi-bold color-dark"
                        variant="outline"
                        onClick={() => { handleView(details?.s3Key) }}
                        size="xs"
                        updatedStyle={{
                            minWidth: "61px",
                            border: "1px solid #CBCBCB",
                            color: "#333",
                            height: "30px"
                        }}
                    >View deposit slip</AButton>

                    <AInput
                        placeholder="Search"
                        className=""
                        value={searchInput}
                        handler={handleOnUserInput}
                        onKeyDown={onKeyDownHandler}
                        searchIconClickHandler={() => {
                            searchInputHandler();
                        }}
                        crossIcon={false}
                        searchIcon={true}
                        style={{ width: "300px" }}
                        crossHandler={crossHandler}
                        customSearchIconStyle={{ left: "5px" }}
                        rightCustomIconStyles={{
                            fontSize: "12px",
                            position: "absolute",
                            bottom: "7px",
                            right: "25%",
                            margin: "auto",
                        }}
                        rightCustomIcon={
                            <select
                                value={selected}
                                onChange={(e) => setSelected(e.target.value)}
                                style={{
                                    position: "absolute",
                                    bottom: "0",
                                    margin: "auto 0",
                                    background: "#FFF6E3",
                                    color: "#A17217",
                                    border: "none",
                                }}
                            >
                                {SEARCH_BY.map(({ key, value }) => (
                                    <option value={key}>{value}</option>
                                ))}
                            </select>
                        }
                        regex={regex?.numeric}
                    />
                </div>
            </div>

            <ReceiptListComponent
                dropdowns={dropdowns}
                rows={details?.receiptDetails}
                loading={loading}
                setLoading={setLoading}
                paginationInfo={paginationInfo}
                cashReceiptId={cashReceiptId}
                setPaginationInfo={setPaginationInfo}
                setDetails={setDetails}
            />
        </Card>
    )
}

export default CashReceiptDetail;